import React, { memo } from "react";

import { Box, Typography, useTheme } from "@mui/material";

import { useTranslation } from "../../../i18n";
import { AllergenChipOutlined } from "../../Chip/Chip";

interface Ingredient {
  igfdTaxIngredientId: string;
  ingredientName: string;
}

interface OptionalIngredientDetailProps {
  ingredient: Ingredient;
  status: "removable" | "not_removable";
  sources?: string[]; // names of optional products at depth 0; non-clickable
}

export const OptionalIngredientDetail = memo(
  ({ ingredient, status, sources: sources }: OptionalIngredientDetailProps) => {
    const { t } = useTranslation();
    const {
      palette: { oscar },
    } = useTheme();

    const chipLabel =
      status === "removable"
        ? t("dish.itemCanBeRemoved", { name: ingredient.ingredientName })
        : ingredient.ingredientName;

    return (
      <Box
        key={ingredient.igfdTaxIngredientId}
        display="flex"
        flexDirection="column"
        alignItems="flex-start"
        gap={0.5}
      >
        <AllergenChipOutlined allergenName={chipLabel} />
        {status === "removable" && sources && sources.length > 0 && (
          <Typography
            color={oscar.light.content.content1}
            variant="labelXSLight"
            textAlign="left"
            sx={{ flexWrap: "wrap", display: "flex", gap: "4px" }}
          >
            <span style={{ fontStyle: "italic" }}>
              {t("allergenDetail.askToRemove")}
            </span>{" "}
            {sources.map((name, idx) => (
              <span key={`carrier-${name}-${idx}`}>
                {name}
                {idx < sources.length - 1
                  ? idx === sources.length - 2
                    ? t("common.listLastSeparator")
                    : t("common.listSeparator")
                  : ""}
              </span>
            ))}
          </Typography>
        )}
      </Box>
    );
  }
);
